module.exports = __webpack_public_path__ + "static/media/Text.53e1f165.svg";